import { useLocation } from "react-router-dom";
import { Lock, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/AppLayout";
import Plans from "@/pages/Plans";
import PaymentReturn from "@/pages/PaymentReturn";

function PayOnlyShell() {
  const { session, logout } = useAuth();
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen" data-testid="pay-only-shell">
      <header className="flex flex-wrap items-center gap-3 border-b border-red-500/20 bg-red-500/10 px-4 py-3 text-sm text-red-500 sm:px-8">
        <Lock className="h-5 w-5 shrink-0" />
        <p className="flex-1" data-testid="pay-only-message">
          <b>Acesso bloqueado por pagamento em atraso.</b> Renove a assinatura de {session.tenant?.nome_fantasia} abaixo: assim que o pagamento for confirmado, o sistema é liberado na hora.
        </p>
        <Button size="sm" variant="outline" className="bg-transparent" onClick={logout} data-testid="pay-only-logout"><LogOut className="h-4 w-4 mr-1" />Sair</Button>
      </header>
      <main className="mx-auto max-w-6xl space-y-6 p-4 sm:p-8">
        {pathname.startsWith("/app/pagamento/retorno") ? <PaymentReturn /> : <Plans />}
      </main>
    </div>
  );
}

export function AppGate() {
  const { session } = useAuth();
  return session.pay_only ? <PayOnlyShell /> : <AppLayout />;
}
